const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:3002/api').replace(/\/api$/, '');

export const getAssetUrl = (path?: string | null): string | undefined => {
  if (!path) {
    return undefined;
  }

  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('data:')) {
    return path;
  }

  return `${API_BASE}${path}`;
};
